var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignificantWeather01 = function SvgSignificantWeather01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "significant_weather-01_svg2__a",
    x1: 22.23,
    x2: 182.61,
    y1: 189.96,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#significant_weather-01_svg2__a",
    id: "significant_weather-01_svg2__b",
    x1: 50.73,
    x2: 211.11,
    y1: 220.54,
    y2: 71.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#significant_weather-01_svg2__a",
    id: "significant_weather-01_svg2__c",
    x1: 2.59,
    x2: 162.97,
    y1: 168.89,
    y2: 19.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#significant_weather-01_svg2__a",
    id: "significant_weather-01_svg2__d",
    x1: 31.33,
    x2: 191.71,
    y1: 199.72,
    y2: 50.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#significant_weather-01_svg2__a",
    id: "significant_weather-01_svg2__e",
    x1: 44.94,
    x2: 205.31,
    y1: 214.33,
    y2: 64.87
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M165.69 71.51c1.01-3.77 1.51-7.69 1.51-11.68 0-25.18-20.49-45.67-45.67-45.67-20.03 0-37.7 13.2-43.59 31.96-4.4-2.44-9.32-3.71-14.45-3.71-16.24 0-29.52 12.97-30.07 29.12C14.85 72.41 0 87.8 0 106.59s15.74 35.08 35.08 35.08h23.14l-18.58 26.04c-2.5 3.51-2.83 8.07-.86 11.9s5.88 6.21 10.19 6.21h102.02c4.31 0 8.21-2.38 10.19-6.21 1.97-3.83 1.65-8.39-.86-11.9l-18.58-26.04h23.17c19.34 0 35.08-15.74 35.08-35.08s-15.32-34.66-34.31-35.08Zm-10.45 99.83c1.16 1.62 1.3 3.64.39 5.41s-2.64 2.82-4.63 2.82H48.98c-1.99 0-3.72-1.05-4.63-2.82s-.77-3.79.39-5.41l51.01-71.51c.99-1.39 2.54-2.18 4.24-2.18s3.25.8 4.24 2.18zm9.68-35.92h-27.63L109.32 96.2c-2.18-3.05-5.58-4.81-9.33-4.81s-7.15 1.75-9.33 4.81l-27.97 39.22h-27.6c-15.9 0-28.83-12.94-28.83-28.83S19.2 77.76 35.09 77.76c.33 0 .71-.02 1.04.04.94.16 1.9-.13 2.6-.77.71-.64 1.08-1.56 1.02-2.51-.04-.61-.08-1.29-.08-1.93 0-13.19 10.69-23.92 23.83-23.92 5.28 0 10.28 1.7 14.47 4.93.85.65 1.99.83 2.99.46a3.09 3.09 0 0 0 1.97-2.3c3.77-18.16 20-31.34 38.61-31.34 21.73 0 39.42 17.68 39.42 39.42 0 4.82-.86 9.49-2.54 13.88-.39 1.02-.22 2.16.44 3.03.66.86 1.73 1.33 2.81 1.2 1.05-.12 2.15-.19 3.25-.19 15.9 0 28.83 12.94 28.83 28.83s-12.93 28.83-28.83 28.83",
    style: {
      fill: "url(#significant_weather-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14 92.85a3.12 3.12 0 0 0-4.41.26 3.13 3.13 0 0 0 .26 4.42c2.6 2.31 4.09 5.62 4.09 9.08 0 .82-.08 1.65-.25 2.45a3.123 3.123 0 0 0 3.07 3.75c1.45 0 2.76-1.02 3.06-2.5a18.452 18.452 0 0 0-5.81-17.46Z",
    style: {
      fill: "url(#significant_weather-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.76 31.16a3.14 3.14 0 0 0-3.55 2.64c-.25 1.71.93 3.3 2.64 3.55 9.45 1.39 17.08 8.61 18.98 17.95.3 1.48 1.6 2.5 3.06 2.5q.315 0 .63-.06a3.133 3.133 0 0 0 2.44-3.69c-2.42-11.92-12.15-21.12-24.2-22.89",
    style: {
      fill: "url(#significant_weather-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.02 153.3c.49.44 1.14.66 1.93.66s1.44-.22 1.91-.66.73-1.02.79-1.73l1.24-22.77v-6.82c0-1.12-.38-2.08-1.12-2.84-.74-.77-1.69-1.16-2.82-1.16s-2.08.39-2.85 1.15-1.16 1.72-1.16 2.85v6.85l1.24 22.76c.05.71.33 1.28.83 1.72Z",
    style: {
      fill: "url(#significant_weather-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.95 158.51c-1.21 0-2.28.45-3.16 1.33s-1.33 1.94-1.33 3.15.45 2.34 1.33 3.22 1.94 1.33 3.16 1.33 2.35-.44 3.23-1.33c.88-.88 1.33-1.96 1.33-3.22s-.45-2.27-1.33-3.15-1.97-1.33-3.23-1.33",
    style: {
      fill: "url(#significant_weather-01_svg2__e)"
    }
  }));
};
export default SvgSignificantWeather01;